import * as DiscountsEditor from 'app/pages/DiscountEditor'
import * as DiscountsList from 'app/pages/DiscountsList'
import * as EarlyBirdOfferList from 'app/pages/EarlyBirdOfferList'
import * as EarlyBirdOfferBuilder from 'app/pages/EarlyBirdOfferBuilder'
import * as AgentPricing from 'app/pages/AgentPricing';
import * as AgentSearch from 'app/pages/AgentSearch';
import * as Pricelist from 'app/pages/PricelistNew';
import * as HolidayManager from 'app/pages/HolidayManager';
import * as Products from 'app/pages/Products';
import * as Cancellations from 'app/pages/Cancellations';
import * as CIM from 'app/pages/CourseIntensityManager';
import CourseLanguageManager from 'app/pages/CourseLanguageManager';
import PortManager from 'app/pages/PortManager';
import CommissionManager from './pages/CommissionManager';
import TaxManager from './pages/TaxManager';
import CategoryManager from './pages/CategoryManager';
import AccountCategoryManager from './pages/AccountCategoryManager';
import {RouteDefinition, RouteDefinitionMap} from 'app/RouteDefinition';
import DivisionManager from './pages/DivisionManager';
import CentreManager from './pages/CentreManager';
import * as NewPricingYear from 'app/pages/NewPricingYear';
import SchoolManager from './pages/SchoolManager';
import RegionManager from './pages/RegionManager';
import * as Calculator from './pages/Calculator';

const Routes : RouteDefinitionMap = {
    'DiscountsEditor': {
        path: '/discount',
        page: DiscountsEditor.Page,
        loadPage: DiscountsEditor.loadPage,
        reducers: DiscountsEditor.reducers
    }, 
    'DiscountsList': {
        path: '/', 
        page: DiscountsList.Page,
        loadPage: DiscountsList.loadPage,
        reducers: DiscountsList.reducers
    },
    'EarlyBirdOfferList': {
        path: '/early-bird-offer',
        page: EarlyBirdOfferList.Page,
        loadPage: EarlyBirdOfferList.loadPage,
        reducers: EarlyBirdOfferList.reducers
    },
    'EarlyBirdOfferBuilder': {
        path: '/early-bird-offer/builder',
        page: EarlyBirdOfferBuilder.Page,
        loadPage: EarlyBirdOfferBuilder.loadPage,
        reducers: EarlyBirdOfferBuilder.reducers
    },
    'AgentSearch': {
        path: '/agents', 
        page: AgentSearch.Page,
        loadPage: AgentSearch.loadPage,
        reducers: AgentSearch.reducers
    },
    'AgentPricing': {
        path: '/agents/rates',
        page: AgentPricing.ViewPage,
        loadPage: AgentPricing.loadViewPage,
        reducers: AgentPricing.viewReducers
    },
    'EditAgentRates': {
        path: '/agents/edit-rates',
        page: AgentPricing.EditPage,
        loadPage: AgentPricing.loadEditDiscountPage,
        reducers: AgentPricing.editDiscountReducers
    },
    'Pricelist': {
        path: '/pricelist',
        page: Pricelist.Page,
        loadPage: Pricelist.loadPage,
        reducers: Pricelist.reducers
    },
    'PricelistDraft': {
        path: '/pricelist/draft',
        page: Pricelist.DraftPage,
        loadPage: Pricelist.loadPage,
        reducers: Pricelist.reducers
    },
    'HolidayManager': {
        path: '/pricelist/holiday-manager',
        page: HolidayManager.Page,
        loadPage: HolidayManager.loadPage,
        reducers: HolidayManager.reducers
    },
    'Products': {
        path: '/products',
        page: Products.Page,
        loadPage: Products.loadPage,
        reducers: Products.reducers
    },
    'Cancellations': {
        path: '/cancellations',
        page: Cancellations.Page,
        loadPage: Products.loadPage,
        reducers: Cancellations.reducers
    },
    'CourseIntensityManager': {
        path: '/course-intensity-manager',
        page: CIM.Page,
        reducers: CIM.reducers
    },
    'CourseLanguageManager': {
        path: '/course-language-manager',
        page: CourseLanguageManager.Page,
        reducers: CourseLanguageManager.reducers
    },
    'PortsandTerminals': {
        path: '/ports-and-terminals',
        page: PortManager.Page,
        reducers: PortManager.reducers,
    },
    'CommissionCategoryManagerAdd': {
        path: '/commission-category-manager/add',
        page: CommissionManager.AddCommissionPage,
        reducers: CommissionManager.reducers,
    },
    'CommissionCategoryManagerEdit': {
        path: '/commission-category-manager/:id',
        page: CommissionManager.AddCommissionPage,
        reducers: CommissionManager.reducers,
    },
    'CommissionCategoryManager': {
        path: '/commission-category-manager',
        page: CommissionManager.Page,
        reducers: CommissionManager.reducers,
    },
    'TaxManagerAdd': {
        path: '/tax-manager/add',
        page: TaxManager.AddTaxPage,
        reducers: TaxManager.reducers,
    },
    'TaxManagerEdit': {
        path: '/tax-manager/:id',
        page: TaxManager.AddTaxPage,
        reducers: TaxManager.reducers,
    },
    'TaxManager': {
        path: '/tax-manager',
        page: TaxManager.Page,
        reducers: TaxManager.reducers,
    },
    'ProductCategoryManager': {
        path: '/product-category-manager',
        page: CategoryManager.Page,
        reducers: CategoryManager.reducers,
    },
    'AccountCategoryManager': {
        path: '/account-category-manager',
        page: AccountCategoryManager.Page,
        reducers: AccountCategoryManager.reducers,
    },
    'DivisionAdd': {
        path: '/division-manager/add',
        page: DivisionManager.DivisionDetails,
        reducers: DivisionManager.reducers,
    },
    'DivisionManager': {
        path: '/division-manager',
         page: DivisionManager.Page,
        reducers: DivisionManager.reducers,
    },
    'DivisionDetails': {
        path: '/division-manager/:id',
        page: DivisionManager.DivisionDetails,
        reducers: DivisionManager.reducers,
    },
    'CentreManager': {
        path: '/centre-manager',
         page: CentreManager.Page,
        reducers: CentreManager.reducers,
    },
    'CentreManagerAdd': {
        path: '/centre-manager/add',
        page: CentreManager.CentreDetailsPage,
        reducers: CentreManager.reducers,
    },
    'CentreManagerEdit': {
        path: '/centre-manager/:id',
        page: CentreManager.CentreDetailsPage,
        reducers: CentreManager.reducers,
    },
    'NewPricingYear': {
        path: '/new-pricing-year',
        page: NewPricingYear.Page,
        reducers: NewPricingYear.reducers,
    },
    'NewPricingYearWizard': {
        path: '/new-pricing-year/wizard',
        page: NewPricingYear.WizardPage,
        reducers: NewPricingYear.reducers,
    },
    'NewPricingYearWizardStep2': {
        path: '/new-pricing-year/wizard/step-2',
        page: NewPricingYear.WizardStepTwo,
        reducers: NewPricingYear.reducers,
    },
    'SchoolManager': {
        path: '/school-manager',
        page: SchoolManager.Page,
        reducers: SchoolManager.reducers,
    },
    'RegionManager': {
        path: '/region-manager',
        page: RegionManager.Page,
        reducers: RegionManager.reducers,
    },
    'Calculator': {
        path: '/calculator',
        page: Calculator.Page,
        loadPage: Calculator.loadPage,
        reducers: Calculator.reducers,
    }

}

export default Routes;